<template>
  <div>
    <!-- RMA Service Center -->
    <div>
      <h3>After-Sales Service</h3>
      <div>
        <!-- 售後服務連結 -->
        <label class="form-item d-flex py-5">
          <div class="w-174px mr-6">
            <h4>售後服務連結</h4>
          </div>
          <div class="flex-grow-1 flex-basis-0 my-n2">
            <v-textarea
              v-model="support.service_line_description"
              outlined
              dense
            ></v-textarea>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    support: {
      type: Object,
      default: () => ({}),
    },
  },
};
</script>

<style></style>
